export default __webpack_public_path__ + "9cd0cff02e1de0eff65b81aa76f6d8ec.png";